import { useMutation } from "@tanstack/react-query";

import { useCurrentOrgId } from "@/providers/auth/hooks";
import { useDomainServices } from "@/providers/DomainServices";

export function useStartSlackOAuth(orgId?: string) {
  const { slackService } = useDomainServices();
  const resolvedOrgId = useCurrentOrgId(orgId);

  return useMutation({
    mutationFn: () => slackService.startOAuthFlow(resolvedOrgId),
  });
}
